import moment from 'moment';

export function convertDateFormat(inputDate, autualFormat, outputFormat) {
  const parsedDate = moment(inputDate, autualFormat);

  if (!parsedDate.isValid()) {
    return 'Invalid Date';
  }

  const formattedDate = parsedDate.format(outputFormat);

  return formattedDate;
}

export function convertDate(inputDate, outputFormat) {
  const parsedDate = moment(inputDate).format(outputFormat);
  return parsedDate;
}

export function startDateValidator(startdate, enddate, autualFormat) {
  const parsedStartDate = moment(startdate, autualFormat);
  const parsedEndDate = moment(enddate, autualFormat);
  if (!parsedStartDate.isValid() || !parsedEndDate.isValid()) {
    return false;
  }
  if (parsedStartDate.isSame(parsedEndDate)) {
    return true;
  } else if (parsedStartDate.isBefore(parsedEndDate)) {
    return true;
  } else {
    return false;
  }
}

export function endDateValidator(startdate, enddate, autualFormat) {
  const parsedStartDate = moment(startdate, autualFormat);
  const parsedEndDate = moment(enddate, autualFormat);
  if (!parsedStartDate.isValid() || !parsedEndDate.isValid()) {
    return false;
  }
  if (parsedEndDate.isSame(parsedStartDate)) {
    return true;
  } else if (parsedEndDate.isAfter(parsedStartDate)) {
    return true;
  } else {
    return false;
  }
}

export const validate30DateRange = (fromDate, toDate, format) => {
  const fromDateObj = moment(fromDate, format, true);
  const toDateObj = moment(toDate, format, true);
  const maxAllowedStartDate = moment(toDateObj).subtract(31, 'days').startOf('day');
  return (
    fromDateObj.isSameOrAfter(maxAllowedStartDate) &&
    fromDateObj.isSameOrBefore(toDateObj)
  );
};

export const validate5DateRange = (fromDate, toDate, format) => {
  const fromDateObj = moment(fromDate, format, true);
  const toDateObj = moment(toDate, format, true);
  const maxAllowedStartDate = moment(toDateObj).subtract(5, 'days').startOf('day');
  return (
    fromDateObj.isSameOrAfter(maxAllowedStartDate) &&
    fromDateObj.isSameOrBefore(toDateObj)
  );
};

export const formatDateStringToDate = (dateString, format) => {
  var momentDate = moment(dateString, format);
  return momentDate.toDate();
};

export function convertToISO8601(localizedString) {
  const date = new Date(localizedString);
  const timezoneOffset = date.getTimezoneOffset() * 60000;
  const adjustedDate = new Date(date.getTime() - timezoneOffset);
  return adjustedDate.toISOString();
}

export const isCurrentDateInRange = (fromDate, toDate) => {
  const currentDate = new Date(); // Get the current date
  const from = new Date(fromDate); // Convert fromDate to a Date object
  const to = new Date(toDate); // Convert toDate to a Date object

  // Normalize all dates to midnight (00:00:00)
  currentDate.setHours(0, 0, 0, 0);
  from.setHours(0, 0, 0, 0);
  to.setHours(0, 0, 0, 0);

  return currentDate >= from && currentDate <= to;
};
